import "./App.css";
import "./components/MainPage/MainPageStyles.css";
import { useRef, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ResetPassword from "./components/MainPage/components/ResetPassword";
import HomePage from "./components/MainPage/HomePage";
import CoursePage from "./components/MainPage/CoursePage";
import { Outlet } from "react-router-dom";
import LearnPage from "./components/Learn2/LearnPage";
import Edit2Page from "./components/Edit2/Edit";
import BookmarksPage from "./components/Bookmarks/BookmarksPage";
import PrivacyPage from "./components/MainPage/PrivacyPage";
import TermsPage from "./components/MainPage/TermsPage";

const StyledLayout = () => {
  return (
    <div className="theme-special-container">
      <Outlet />
    </div>
  );
};

const App = () => {
  const loginToken = process.env.REACT_APP_GOOGLE_API_TOKEN;

  const [importsLoaded, setImportsLoaded] = useState(false);

  const EditContent = useRef(null);
  const EditCourseStructure = useRef(null);
    const EditSupport = useRef(null);

  async function do_imports() {
    if (process.env.REACT_APP_CONFIGURATION === "development") {
      EditContent.current = (
        await import("./components/Edit2/EditContent")
      ).default;
      EditCourseStructure.current = (
        await import("./components/Edit2/EditCourseStructure")
      ).default;
        EditSupport.current = (await import('./components/Edit2/EditSupport')).default
      setImportsLoaded(true);
    }
  }

  useEffect(() => {
    do_imports();
  });

  return (
    <GoogleOAuthProvider clientId={loginToken}>
      <BrowserRouter>
        <Routes>
          <Route element={<StyledLayout />}>
            <Route
              exact
              path="/"
              element={<Navigate replace={true} to="/courses" />}
            />
            <Route exact path="/courses/:id" element={<CoursePage />} />
            <Route
              exact
              path="/courses"
              element={<HomePage showSearchResults={false} />}
            />
            <Route
              exact
              path="/courses/search"
              element={<HomePage showSearchResults={true} />}
            />
            <Route path="/resetpassword/:token" element={<ResetPassword />} />
            <Route exact path="/learn/:id" element={<LearnPage />} />
            <Route exact path="/bookmarks" element={<BookmarksPage />} />
            <Route exact path="/edit2" element={<Edit2Page />} />
            <Route exact path="/privacy" element={<PrivacyPage />} />
            <Route exact path="/terms" element={<TermsPage />} />
          </Route>
          {importsLoaded && (
            <Route
              exact
              path="/editcoursestructure/:id"
              element={<EditCourseStructure.current />}
            />
          )}
          {importsLoaded && (
            <Route
              exact
              path="/editcontent/:id"
              element={<EditContent.current />}
            />
          )}
          {importsLoaded && <Route exact path="/editsupport/" element={<EditSupport.current />} />}
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
